import React from 'react'
import { concatStyles } from 'utils'

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  secondary?: boolean
}

export const Label: React.FC<LabelProps> = ({ secondary, ...props }) => {
  return (
    <label
      className={concatStyles(
        'flex p-0 pb-1 m-0 flex-grow-0 flex-row text-sm font-body',
        secondary ? 'text-secondary' : 'text-primary'
      )}
      {...props}
    >
      {props.children}
    </label>
  )
}

export default Label
